var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipsisinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 5,
  fill: "none",
  viewBox: "0 0 25 5"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 2.5,
  r: 2.5,
  fill: "currentColor",
  transform: "rotate(-180 22.5 2.5)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 2.5,
  r: 2.5,
  fill: "currentColor",
  transform: "rotate(-180 12.5 2.5)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  fill: "currentColor",
  transform: "rotate(-180 2.5 2.5)"
})));
export default SvgEllipsisinline;